<template>
  <div>
    <v-btn color="primary" dark @click.stop="dialog = true">
      Novo Checklist
    </v-btn>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline green white--text darken-2" primary-title>
          Criar Checklist
        </v-card-title>

        <v-card-text>

          <v-form v-model="valid">
            <v-select :items="applicationTypes" v-model="applicationType" label="Digite para buscar e selecione uma opção"
              item-text="name" item-value="value" return-object autocomplete></v-select>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" flat @click="createChecklist()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ApplicationTypeService from '@/services/applications/configurations/ApplicationTypeService';
import ChecklistService from '@/services/applications/configurations/ChecklistService';

export default {
  name: 'CreateChecklist',
  components: {},
  props: ['typology'],
  mounted() {
    ApplicationTypeService
      .fetchApplicationTypes()
      .then(({ data }) => {
        this.applicationTypes = data;
      });
  },
  data() {
    return {
      dialog: false,
      valid: false,
      applicationType: '',
      applicationTypes: [],
    };
  },
  methods: {
    createChecklist() {
      const vm = this;
      ChecklistService
        .createChecklist(vm.applicationType.id, vm.typology.id)
        .then((response) => {
          vm.$swal({
            title: 'Checklist criado com Sucesso',
            text: '',
            type: 'success',
            confirmButtonText: 'Ok',
          }).then(() => {
            vm.checklist = {};
            const checklist = response.data;
            checklist.document_types = [];
            vm.$emit('checklist-created', checklist);
            vm.dialog = false;
          });
        })
        .catch((error) => {
          vm.$swal({
            title: 'Erro',
            text: error.response.data.join('\n'),
            type: 'error',
            showConfirmButton: 'Ok',
          });
        });
    },
  },
};
</script>

<style scoped lang="scss"></style>
